<template>
    <div class="card card-menu mb-5" v-if="model">
        <div class="card-body pt-4 pb-0">
            <div class="d-flex justify-content-between align-items-start flex-wrap">
                <div class="d-flex flex-column">
                    <div class="text-white fs-2 fw-bolder mb-1">{{ model.descricao }}</div>
                    <div class="text-gray-300 fw-bold fs-6">
                        <span class="me-4"><i class="fa fa-calendar-week text-white me-1"></i>{{ periodo }}</span>
                        <span class="me-4" v-if="quadroBase"><i class="fa fa-table-list text-white me-1"></i>{{ quadroBase }}</span>
                        <span class="badge" :class="badgeClass">{{ statusLabel }}</span>
                    </div>
                </div>
                <div class="d-flex my-2">
                    <button v-if="hasPermissaoEditar && mostrarGerar" @click="gerar"
                        class="btn btn-sm btn-pmes-warning me-2" :disabled="processando">
                        <i class="fa fa-bolt"></i> {{ statusId === 2 ? 'Regerar QTS' : 'Gerar QTS' }}
                    </button>
                    <button v-if="hasPermissaoEditar && mostrarValidar" @click="validar"
                        class="btn btn-sm btn-light-pmes-dark-primary me-2" :disabled="processando">
                        <i class="fa fa-clipboard-check"></i> Validar
                    </button>
                    <button v-if="hasPermissaoPublicar && mostrarPublicar" @click="publicar"
                        class="btn btn-sm btn-light-pmes-dark-primary me-2" :disabled="processando">
                        <i class="fa fa-circle-check"></i> Publicar
                    </button>
                    <button v-if="hasPermissaoPublicar && mostrarCancelar" @click="cancelar"
                        class="btn btn-sm btn-light-danger me-2" :disabled="processando">
                        <i class="fa fa-ban"></i> Cancelar
                    </button>
                    <button v-if="hasPermissaoEditar && podeLimparAlocacoes" @click="limparAlocacoes"
                        class="btn btn-sm btn-light-danger me-2" :disabled="processando"
                        title="Apagar todas as alocações deste QTS">
                        <i class="fa fa-trash"></i> Apagar alocações
                    </button>
                    <!-- <button @click="exportarPdf" class="btn btn-sm btn-light me-2" :disabled="processando"
                        title="Exportar o QTS em PDF (uma página por pelotão)">
                        <i class="fa fa-file-pdf text-danger"></i> PDF
                    </button>
                    <button @click="exportarPdfPorHorario" class="btn btn-sm btn-light me-2" :disabled="processando"
                        title="Exportar a relação de alocações por horário em PDF">
                        <i class="fa fa-file-pdf text-danger"></i> PDF por horário
                    </button> -->
                    <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal', params: { id: turmaId } }"
                        class="btn btn-sm btn-light border border-pmes-primary">
                        <i class="fas fa-arrow-left text-pmes-primary"></i> Voltar
                    </router-link>
                </div>
            </div>

            <div class="d-flex overflow-auto h-55px">
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 fw-bolder flex-nowrap">
                    <li class="nav-item">
                        <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal_show_dias' }"
                            class="nav-link text-active-secondary me-6" active-class="active">Dias</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal_show_disciplinas' }"
                            class="nav-link text-active-secondary me-6" active-class="active">Disciplinas</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal_show_alocacoes' }"
                            class="nav-link text-active-secondary me-6" active-class="active">Alocações</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal_show_impedimentos' }"
                            class="nav-link text-active-secondary me-6" active-class="active">Impedimentos</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'sigap_turma_qts_gerador_qtssemanal_show_pdf' }"
                            class="nav-link text-active-secondary me-6" active-class="active">PDF</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <router-view v-if="model" :key="model.id" :perfis="perfis" :turma="turmaObj" :qtsSemanalId="model.id"
        :statusId="statusId" :reload="reloadGrade" :model="model" />

    <!-- Modal de diagnóstico (geração / validação) -->
    <div class="modal fade" id="kt_qts_semanal_diagnostico" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="m-0">{{ diagnostico.titulo }}</h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y mx-5 my-4">
                    <div class="alert d-flex align-items-center p-4 mb-4"
                        :class="diagnostico.ok ? 'alert-light-success' : 'alert-light-danger'">
                        <i class="fa fs-2 me-3" :class="diagnostico.ok ? 'fa-circle-check text-success' : 'fa-triangle-exclamation text-danger'"></i>
                        <div>
                            <div class="fw-bold">{{ diagnostico.ok ? 'Sucesso' : 'Atenção' }}</div>
                            <div>{{ diagnostico.mensagem }}</div>
                            <div class="text-muted fs-7" v-if="diagnostico.meta">{{ diagnostico.meta }}</div>
                        </div>
                    </div>

                    <div v-if="diagnostico.erros.length" class="mb-4">
                        <label class="fw-bold text-danger">Erros</label>
                        <ul class="mb-0"><li v-for="(e, i) in diagnostico.erros" :key="'e' + i">{{ e }}</li></ul>
                    </div>

                    <div v-if="diagnostico.violacoes.length" class="mb-4">
                        <label class="fw-bold text-danger">Violações de regras</label>
                        <ul class="mb-0"><li v-for="(v, i) in diagnostico.violacoes" :key="'v' + i">{{ v }}</li></ul>
                    </div>

                    <div v-if="diagnostico.avisos.length" class="mb-4">
                        <label class="fw-bold text-warning">Avisos</label>
                        <ul class="mb-0"><li v-for="(a, i) in diagnostico.avisos" :key="'a' + i">{{ a }}</li></ul>
                    </div>

                    <div v-if="diagnostico.blocos.length">
                        <label class="fw-bold text-danger">Blocos não alocados</label>
                        <table class="table table-row-bordered align-middle">
                            <thead>
                                <tr class="fw-bold text-muted">
                                    <th>Disciplina</th>
                                    <th class="text-center">Pelotão</th>
                                    <th class="text-center">Tamanho</th>
                                    <th>Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(b, i) in diagnostico.blocos" :key="'b' + i">
                                    <td>{{ b.disciplinaDescricao || ('Disc ' + b.disciplinaId) }}</td>
                                    <td class="text-center">{{ b.pelotao }}</td>
                                    <td class="text-center">{{ b.tamanho }}</td>
                                    <td>{{ b.motivo }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <button ref="abrirDiagnostico" data-bs-toggle="modal" data-bs-target="#kt_qts_semanal_diagnostico"
        style="display:none"></button>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { labelStatusQts, statusQtsId, podeGerar, podeValidar, podePublicar, podeCancelar } from "./constantes";

const authStore = namespace('auth');

@Options({
    name: "QtsSemanalShow",
    components: {},
})
export default class QtsSemanalShow extends Vue {

    @authStore.Getter
    public perfis!: any

    @authStore.Getter
    public token!: any

    public service = new QtsSemanalService();
    public model: any = null;
    public processando = false;
    public reloadGrade = false;
    public diagnostico: any = this.diagnosticoVazio();

    private diagnosticoVazio() {
        return { titulo: '', ok: true, mensagem: '', meta: '', erros: [], avisos: [], violacoes: [], blocos: [] };
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get hasPermissaoPublicar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    get isAdmin(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin ], this.perfis);
    }

    get statusId(): number {
        return this.model ? statusQtsId(this.model.status) : 0;
    }

    get mostrarGerar(): boolean { return this.model ? podeGerar(this.model.status) : false; }
    get mostrarValidar(): boolean { return this.model ? podeValidar(this.model.status) : false; }
    get mostrarPublicar(): boolean { return this.model ? podePublicar(this.model.status) : false; }
    get mostrarCancelar(): boolean { return this.model ? podeCancelar(this.model.status) : false; }
    // Pode apagar alocações em qualquer status, exceto PUBLICADO (4).
    get podeLimparAlocacoes(): boolean { return !!this.model && (this.statusId !== 4 || this.isAdmin ); }

    get turmaId() {
        return this.$route.params.id;
    }

    get turmaObj() {
        return { id: this.turmaId };
    }

    get statusLabel() {
        return this.model ? labelStatusQts(this.model.status) : '';
    }

    get badgeClass() {
        const v = this.model && typeof this.model.status === 'object' ? this.model.status.id : this.model?.status;
        switch (Number(v)) {
            case 1: return 'badge-light';            // RASCUNHO
            case 2: return 'badge-light-primary';    // GERADO
            case 3: return 'badge-light-info';       // VALIDADO
            case 4: return 'badge-light-success';    // PUBLICADO
            case 5: return 'badge-light-danger';     // CANCELADO
            default: return 'badge-light';
        }
    }

    get periodo() {
        const ini = this.fmt(this.model?.inicio);
        const fim = this.fmt(this.model?.fim);
        return ini || fim ? `${ini} a ${fim}` : 'Período não definido';
    }

    get quadroBase() {
        return this.model?.quadroHorario?.descricao ?? '';
    }

    private fmt(v: any) {
        if (!v) return '';
        const s = String(v).substring(0, 10);
        const p = s.split('-');
        return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
    }

    created() {
        this.buscar();
    }

    public buscar() {
        this.processando = true;
        this.service.getModel(this.$route.params.qtsSemanalId)
            .then(r => {
                this.model = JSON.parse(JSON.stringify(r));
                this.processando = false;
            })
            .catch(() => { this.processando = false; });
    }

    public exportarPdf() {
        if (this.processando || !this.model) return;
        const url = this.service.getPdfUrl(this.model.id, this.token);
        window.open(url, '_blank');
    }

    public exportarPdfPorHorario() {
        if (this.processando || !this.model) return;
        const url = this.service.getPdfPorHorarioUrl(this.model.id, this.token);
        window.open(url, '_blank');
    }

    public limparAlocacoes() {
        if (this.processando || !this.model) return;
        SiteUtils.alertConfimacao('Apagar todas as alocações deste QTS?',
            'Esta ação não pode ser desfeita. Um QTS gerado/validado voltará a RASCUNHO.',
            () => {
                this.processando = true;
                this.service.limparAlocacoes(this.model.id)
                    .then(response => {
                        this.processando = false;
                        SiteUtils.toastSucesso('Alocações apagadas!', `${response?.removidas ?? 0} alocação(ões) removida(s).`);
                        this.reloadGrade = !this.reloadGrade;
                        this.buscar();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Erro ao apagar alocações', error?.data?.message);
                    });
            }
        );
    }

    private abrirDiagnostico() {
        this.$nextTick(() => (this.$refs.abrirDiagnostico as HTMLElement)?.click());
    }

    public gerar() {
        if (this.processando || !this.model) return;
        SiteUtils.alertConfimacao('Gerar o QTS para esta configuração?', 'As alocações serão (re)geradas.',
            () => {
                this.processando = true;
                this.service.gerar(this.model.id)
                    .then(response => {
                        this.processando = false;
                        const r = response || {};
                        this.diagnostico = {
                            titulo: 'Resultado da geração',
                            ok: !!r.sucesso,
                            mensagem: r.mensagem || (r.sucesso ? 'Geração concluída.' : 'Não foi possível gerar o QTS.'),
                            meta: `Iterações: ${r.iteracoes ?? 0} · Tempo: ${r.tempoMs ?? 0} ms · Alocações: ${(r.alocacoes || []).length}`,
                            erros: r.erros || [],
                            avisos: r.avisos || [],
                            violacoes: [],
                            blocos: r.blocosNaoAlocados || [],
                        };
                        if (r.sucesso) {
                            SiteUtils.toastSucesso('Geração concluída!', r.mensagem);
                            this.$router.push({ name: 'sigap_turma_qts_gerador_qtssemanal_show_alocacoes' });
                            this.reloadGrade = !this.reloadGrade;
                        } else {
                            SiteUtils.toastErro('Geração não concluída', r.mensagem);
                        }
                        this.abrirDiagnostico();
                        this.buscar();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Erro ao gerar', error?.data?.message);
                    });
            }
        );
    }

    public validar() {
        if (this.processando || !this.model) return;
        this.processando = true;
        this.service.validar(this.model.id)
            .then(response => {
                this.processando = false;
                const r = response || {};
                this.diagnostico = {
                    titulo: 'Resultado da validação',
                    ok: !!r.ok,
                    mensagem: r.mensagem || (r.ok ? 'QTS validado.' : 'O QTS possui violações.'),
                    meta: '',
                    erros: [],
                    avisos: [],
                    violacoes: r.violacoes || [],
                    blocos: [],
                };
                if (r.ok) SiteUtils.toastSucesso('QTS validado!', r.mensagem);
                else SiteUtils.toastErro('Validação reprovada', r.mensagem);
                this.abrirDiagnostico();
                this.buscar();
            })
            .catch(error => {
                this.processando = false;
                SiteUtils.toastErro('Erro ao validar', error?.data?.message);
            });
    }

    public publicar() {
        if (this.processando || !this.model) return;
        SiteUtils.alertConfimacao('Publicar o QTS?', 'Após publicado, o QTS é congelado e não pode ser alterado.',
            () => {
                this.processando = true;
                this.service.publicar(this.model.id)
                    .then(response => {
                        this.processando = false;
                        SiteUtils.toastSucesso('QTS publicado!', response?.message);
                        this.buscar();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Erro ao publicar', error?.data?.message);
                    });
            }
        );
    }

    public cancelar() {
        if (this.processando || !this.model) return;
        SiteUtils.alertConfimacao('Cancelar o QTS?', 'O QTS será marcado como cancelado.',
            () => {
                this.processando = true;
                this.service.cancelar(this.model.id)
                    .then(response => {
                        this.processando = false;
                        SiteUtils.toastSucesso('QTS cancelado!', response?.message);
                        this.buscar();
                    })
                    .catch(error => {
                        this.processando = false;
                        SiteUtils.toastErro('Erro ao cancelar', error?.data?.message);
                    });
            }
        );
    }
}
</script>

<style scoped>
.card-menu {
    background-color: #304988 !important;
}

.nav-line-tabs .nav-item .nav-link {
    margin: 0 0.8rem !important;
}

.nav-line-tabs .nav-item .nav-link.active,
.nav-line-tabs .nav-item.show .nav-link,
.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
    border-bottom: 3px solid #E3A11E;
}
</style>
